import React from 'react';
import { Button, notification } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { SwapOutlined } from '@ant-design/icons';

import { updateBrokerStatus } from 'services/parametersService';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';

export type EnableDisableBrokerButtonProps = ButtonProps & {
  mgid: number;
  associd: number;
  statusToUpdate: string;
  refetch?: () => void;
};

const EnableDisableBrokerButton: React.FC<EnableDisableBrokerButtonProps> = ({
  size = 'small',
  refetch,
  statusToUpdate,
  mgid,
  associd,
  ...props
}) => {
  const { getComponentLabel } = useDisplayFrameworkContext();
  // const status = statusToUpdate === 'ENABLED' ? 'DISABLED' : 'ENABLED';

  const getStatus = () => {
    if (statusToUpdate === 'ENABLE') {
      return 'DISABLED';
    } else if (statusToUpdate === 'DISABLED') {
      return 'TERMINATE';
    } else {
      return 'ACTIVE';
    }
  };

  return (
    <Button
      style={{ height: 40 }}
      icon={<SwapOutlined />}
      onClick={() => {
        const status = getStatus();
        updateBrokerStatus({
          mgid,
          associd,
          status,
        }).then(() => {
          notification.success({ message: 'Broker updated' });
          refetch && refetch();
        });
      }}
      {...props}
    >
      {getComponentLabel(getStatus())}
    </Button>
  );
};

export default EnableDisableBrokerButton;
